// FilterBar — T083


interface FilterBarProps {
  filters: {
    status: string[];
    hostingProvider: string;
    providerAccount: string;
    client: string;
    name: string;
    dnsMutated?: string;
  };
  onChange: (filters: any) => void;
  availableProviders?: string[];
  availableAccounts?: string[];
  availableClients?: string[];
}

const STATUS_OPTIONS = ['UP', 'DEGRADED', 'DOWN'];

export default function FilterBar({ filters, onChange, availableProviders = [], availableAccounts = [], availableClients = [] }: FilterBarProps) {
  const toggleStatus = (status: string) => {
    const current = filters.status;
    const next = current.includes(status)
      ? current.filter((s) => s !== status)
      : [...current, status];
    onChange({ ...filters, status: next });
  };

  return (
    <div className="flex flex-wrap gap-3 items-center mb-4">
      {/* Status filters */}
      <div className="flex gap-1">
        {STATUS_OPTIONS.map((s) => (
          <button
            key={s}
            onClick={() => toggleStatus(s)}
            className={`px-3 py-1.5 rounded text-sm font-medium min-h-[44px] transition-colors ${
              filters.status.includes(s)
                ? s === 'UP' ? 'bg-status-up text-white' : s === 'DEGRADED' ? 'bg-status-degraded text-black' : 'bg-status-down text-white'
                : 'bg-surface text-text-secondary hover:bg-surface-hover'
            }`}
          >
            {s}
          </button>
        ))}
      </div>

      {/* Tag filters */}
      {availableProviders.length > 0 && (
        <select
          aria-label="Hosting Provider"
          value={filters.hostingProvider}
          onChange={(e) => onChange({ ...filters, hostingProvider: e.target.value })}
          className="bg-surface text-text-primary border border-border rounded px-3 py-1.5 text-sm min-h-[44px]"
        >
          <option value="">All Providers</option>
          {availableProviders.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      )}

      {availableAccounts.length > 0 && (
        <select
          aria-label="Provider Account"
          value={filters.providerAccount}
          onChange={(e) => onChange({ ...filters, providerAccount: e.target.value })}
          className="bg-surface text-text-primary border border-border rounded px-3 py-1.5 text-sm min-h-[44px]"
        >
          <option value="">All Accounts</option>
          {availableAccounts.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      )}

      {availableClients.length > 0 && (
        <select
          aria-label="Client"
          value={filters.client}
          onChange={(e) => onChange({ ...filters, client: e.target.value })}
          className="bg-surface text-text-primary border border-border rounded px-3 py-1.5 text-sm min-h-[44px]"
        >
          <option value="">All Clients</option>
          {availableClients.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      )}

      {/* DNS Mutated Toggle */}
      <button
        type="button"
        onClick={() => onChange({ ...filters, dnsMutated: filters.dnsMutated === 'true' ? '' : 'true' })}
        className={`px-3 py-1.5 rounded text-sm font-medium min-h-[44px] transition-colors border flex items-center gap-2 ${
          filters.dnsMutated === 'true'
            ? 'bg-amber-600 text-white border-amber-600 hover:bg-amber-700'
            : 'bg-surface text-text-secondary border-border hover:bg-surface-hover'
        }`}
      >
        <span className="inline-block w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
        DNS Mutated Only
      </button>

      <input
        type="text"
        placeholder="Search monitors…"
        aria-label="Search monitors by name"
        value={filters.name ?? ''}
        onChange={(e) => onChange({ ...filters, name: e.target.value })}
        className="bg-surface text-text-primary border border-border rounded px-3 py-1.5 text-sm min-h-[44px]"
      />
    </div>
  );
}
